import { DownloadState } from '@repo/core'
import { RootState } from '../../store/types'

export const communicationDocumentDownloadSelectorConfig = {
  communicationDocumentDownloadSelector: {
    getRootPath: function (state: RootState): DownloadState {
      return state.mailbox.communications.documentDownload
    },
  },
}
